<template>
  <b-collapse
    :model-value="open"
    animation="slide"
    aria-id="collapseForTags"
    class="tagsCollapse"
  >
    <template #trigger="props">
      <div
        :aria-expanded="props.open"
        aria-controls="collapseForTags"
        class="card-header"
      >
        <p
          class="card-header-title"
          :aria-label="$t('tags.tag')"
        >
          {{ $t("tags.tag") }}
        </p>
        <a
          class="card-header-icon"
          tabindex="0"
          @keyup.enter="open = !open"
          @keyup.space="open = !open"
        >
          <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'" />
        </a>
      </div>
    </template>
    <div class="card-content">
      <div class="content columns">
        <b-switch
          v-model="allTags"
          class="column is-narrow"
          :aria-label="$t('tags.allTags')"
          type="is-warning"
          @input="changeAllTags($event)"
        >
          {{ $t("tags.allTags") }}
        </b-switch>
      </div>
      <div class="content columns">
        <b-field
          v-for="(tag, key) in tags"
          :key="tag.tagName"
          class="column is-narrow"
        >
          <b-switch
            v-model="tag.selected"
            :aria-label="key === 'no_tag' ? $t('tags.no-tag') : tag.localName"
            type="is-dark"
            @input="changeTag(key, $event)"
          >
            {{ key === "no_tag" ? $t("tags.no-tag") : tag.localName }}
          </b-switch>
        </b-field>
      </div>
    </div>
  </b-collapse>
</template>

<script lang="ts">
import useBoolean from "@/composable/components/boolean";
import "@/style/components/TagsCollapse.scss";
import { BCollapse, BField, BIcon, BSwitch } from "buefy";

export default {
  name: "TagsCollapse",
  components: { BField, BSwitch, BIcon, BCollapse },

  props: {
    tags: {
      type: Object,
      required: true,
    },
  },

  emits: ["change:tag", "change:allTags"],

  setup(props, { emit }) {
    const { refBoolean: open } = useBoolean();
    const { refBoolean: allTags } = useBoolean(true);

    function changeTag(key: string, event: Event) {
      const checked = (event.target as HTMLInputElement).checked;
      emit("change:tag", { key, checked });
    }

    function changeAllTags(event: Event) {
      const checked = (event.target as HTMLInputElement).checked;
      emit("change:allTags", checked);
    }

    return {
      open,
      allTags,
      changeTag,
      changeAllTags,
    };
  },
};
</script>
